import { fetchTaxonContent } from "./helpers/taxonomy-api.helper";
import { useSelectedNodeStore } from "./store/selected-node.store";
import { pubsub } from "@assets/js/imaios-global/imaios-global";

/**
 * Fetch new content by AJAX & update selected Node Store
 * @param {string} application
 * @param {string} url
 * @param {boolean} refreshTree
 * @param {boolean} fetchByNavigation true if fetch by window navigate back/forward
 * @return
 */
export async function fetchAndSelectItem(
  application: string,
  url: string,
  refreshTree: boolean | false,
  fetchByNavigation: boolean | false
): void {
  const selectedNodeStore = useSelectedNodeStore();
  let newSelectNode = "";

  //Push Url in window history if it's NOT a fetch by navigation
  if (!fetchByNavigation) {
    window.history.pushState(null, "", url);
  }

  //analytics set
  updateAnalyticsSet(window.imaios.get("application"));

  //adding skeleton on loading
  addSkeletonOnLoading(application);

  try {
    const taxonContent = await fetchTaxonContent(url);

    const newContent = taxonContent.getElementById(
      `${application}-frontpage-content`
    );

    //update Selected Node Path by new content
    newSelectNode = newContent?.dataset.nodePath;

    //Update content by AJAX
    updateNewContent(application, taxonContent);
  } catch (error) {
    window.NREUM?.notifyError(error);
  } finally {
    selectedNodeStore.setSelectedNodePath(newSelectNode);
    if (refreshTree) pubsub.publish("refreshTree", url);
    pubsub.publish("reloadApp");
  }
}

function updateNewContent(application: string, taxonContent: Document): void {
  //Update Breadcrumb
  const newBreadcrumb = taxonContent.querySelector(".breadcrumb");
  const currentBreadcrumb = document.querySelector(".breadcrumb");

  if (newBreadcrumb && currentBreadcrumb) {
    currentBreadcrumb.replaceWith(newBreadcrumb);
  }

  //Update Language Dropdown on Header
  const newLangDropdown = taxonContent.getElementById("languageLinkContainer");
  const currentLangDropdown = document.getElementById("languageLinkContainer");

  if (newLangDropdown && currentLangDropdown) {
    currentLangDropdown.replaceWith(newLangDropdown);
  }

  //Update Content
  const newContent = taxonContent.getElementById(`${application}-frontpage-content`);
  const currentContent = document.getElementById(`${application}-frontpage-content`);

  if (newContent && currentContent) {
    currentContent.replaceWith(newContent);
  }

  //Additional Content
  switch (application) {
    case "anatomical": {
      const newTitle = taxonContent.querySelector("head title");
      const currentTitle = document.querySelector("head title");
      if (newTitle && currentTitle) {
        currentTitle.replaceWith(newTitle);
      }
      break;
    }
    case "zoopaedia": {
      break;
    }
  }
}

function addSkeletonOnLoading(application: string): void {
  switch (application) {
    case "anatomical": {
      // Hide the structure definition button container
      document.getElementById("structure-headerDefinition")?.classList.add("d-none");

      // Apply skeleton styles to all elements tag of article
      document.querySelector("article")?.classList.add("article-skeleton");

      // Apply skeleton styles to direct div children of aside
      document.querySelector("aside")?.classList.add("aside-skeleton");

      break;
    }
    case "zoopaedia": {
      const titleSkeleton = Array.from(
        document.querySelectorAll('[data-skeleton="title"]')
      );
      const cardSkeleton = Array.from(
        document.querySelectorAll('[data-skeleton="card"]')
      );

      titleSkeleton.forEach((item) =>
        item.classList.add("title-content-skeleton")
      );
      cardSkeleton.forEach((card, key) =>
        key === 0
          ? card.classList.add("card-skeleton")
          : card.classList.add("d-none")
      );
      document.querySelector(".block-title").classList.add("d-none");

      break;
    }
  }
}

function updateAnalyticsSet(applicationStore: string): void {
  let valueApplication = "";

  switch (applicationStore) {
    case "e-anatomy":
    case "eanatomy":
      valueApplication = "structurehuman";
      break;

    case "vet-anatomy":
    case "vetanatomy":
      valueApplication = "structurevet";
      break;

    case "zoo-paedia":
    case "zoopaedia":
      valueApplication = "zoopaedia";
      break;
  }

  imaios.pubsub.publish("analytics-set", {
    key: "content_group",
    value: valueApplication,
  });
}
